
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as homel_45wg6kefYB8SxqXzOTQBxGAN5B54uCY_LiinGlj1IU4Meta } from "/opt/buildhome/repo/pages/home.vue?macro=true";
import { default as errorHLFY7zwFUrfpprhDfpUcz1_Gwa8d9C_XhlejYbumvDkMeta } from "/opt/buildhome/repo/pages/error.vue?macro=true";
import { default as loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta } from "/opt/buildhome/repo/pages/login.vue?macro=true";
import { default as sales4cCF4kluTTAELgC1CcqH_458s1GvKbbMBsbDrsbE2icckMeta } from "/opt/buildhome/repo/pages/sales.vue?macro=true";
import { default as _91id_93SLLbbtPyYZU0_RE8O1MhF49ehlUNIPtg_L7hHVi4alUMeta } from "/opt/buildhome/repo/pages/otp/[id].vue?macro=true";
import { default as registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta } from "/opt/buildhome/repo/pages/register.vue?macro=true";
import { default as dashboardAD_451mrT_EUTWtWLxQnqVQ_45hCD6MuBiMzQsV5qGLZFZMMeta } from "/opt/buildhome/repo/pages/dashboard.vue?macro=true";
import { default as playgroundP4xHVesktRUHS4AcaLsGDI3PiDlXrUQUIfJNAEHnDe4Meta } from "/opt/buildhome/repo/pages/playground.vue?macro=true";
import { default as release_45notedQRGTYo3TRkrnA9RZFhfzY6Xu20ycsAX8k_45CZg2V1VYMeta } from "/opt/buildhome/repo/pages/release-note.vue?macro=true";
import { default as system_45introKAhTm9_0aT3OTHVwF2bfRBr336Up3m0Xul7SxHmWCFkMeta } from "/opt/buildhome/repo/pages/system-intro.vue?macro=true";
export default [
  {
    name: "home",
    path: "/home",
    meta: homel_45wg6kefYB8SxqXzOTQBxGAN5B54uCY_LiinGlj1IU4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/home.vue")
  },
  {
    name: "error",
    path: "/error",
    component: () => import("/opt/buildhome/repo/pages/error.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginKMdcZdjxVWBby7qzc8iax1m1i6js8gN3t8PvZM_RwR8Meta || {},
    component: () => import("/opt/buildhome/repo/pages/login.vue")
  },
  {
    name: "sales",
    path: "/sales",
    meta: sales4cCF4kluTTAELgC1CcqH_458s1GvKbbMBsbDrsbE2icckMeta || {},
    component: () => import("/opt/buildhome/repo/pages/sales.vue")
  },
  {
    name: "otp-id",
    path: "/otp/:id()",
    meta: _91id_93SLLbbtPyYZU0_RE8O1MhF49ehlUNIPtg_L7hHVi4alUMeta || {},
    component: () => import("/opt/buildhome/repo/pages/otp/[id].vue")
  },
  {
    name: "register",
    path: "/register",
    meta: registerI5bGXMcIgYuI09GEDHsdRYBdRTdvAXNx2bsszLTicp0Meta || {},
    component: () => import("/opt/buildhome/repo/pages/register.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: dashboardAD_451mrT_EUTWtWLxQnqVQ_45hCD6MuBiMzQsV5qGLZFZMMeta || {},
    component: () => import("/opt/buildhome/repo/pages/dashboard.vue")
  },
  {
    name: "playground",
    path: "/playground",
    meta: playgroundP4xHVesktRUHS4AcaLsGDI3PiDlXrUQUIfJNAEHnDe4Meta || {},
    component: () => import("/opt/buildhome/repo/pages/playground.vue")
  },
  {
    name: "release-note",
    path: "/release-note",
    meta: release_45notedQRGTYo3TRkrnA9RZFhfzY6Xu20ycsAX8k_45CZg2V1VYMeta || {},
    component: () => import("/opt/buildhome/repo/pages/release-note.vue")
  },
  {
    name: "system-intro",
    path: "/system-intro",
    meta: system_45introKAhTm9_0aT3OTHVwF2bfRBr336Up3m0Xul7SxHmWCFkMeta || {},
    component: () => import("/opt/buildhome/repo/pages/system-intro.vue")
  }
]